import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUserShield, FaUser } from 'react-icons/fa';
import './Sidebar.css';
import { AuthContext } from '../../context/AuthContext';
import { useDownloadApp } from './useDownloadApp';
import SidebarProfile from './SidebarProfile';

import walletsActive from '../../assets/sidebar_icons/wallets_active.png';
import walletsInactive from '../../assets/sidebar_icons/wallets_inactive.png';
import dashboardActive from '../../assets/sidebar_icons/dashboard_active.png';
import dashboardInactive from '../../assets/sidebar_icons/dashboard_inactive.png';
import withdrawActive from '../../assets/sidebar_icons/withdraw_active.png';
import withdrawInactive from '../../assets/sidebar_icons/withdraw_inactive.png';
import affiliateActive from '../../assets/sidebar_icons/affiliate_active.png';
import affiliateInactive from '../../assets/sidebar_icons/affiliate_inactive.png';

const Sidebar = () => {
  const location = useLocation();
  const { user, reportActivity } = useContext(AuthContext);
  const { handleDownload, generatingLink, downloadError } = useDownloadApp();

  // Fires whenever the user navigates to a new route
  useEffect(() => {
    reportActivity(location.pathname);
  }, [location.pathname]);

  const navItems = [
    { path: '/wallets', name: 'Wallets', activeIcon: walletsActive, inactiveIcon: walletsInactive },
    { path: '/dashboard', name: 'Dashboard', activeIcon: dashboardActive, inactiveIcon: dashboardInactive },
    { path: '/withdraw', name: 'Withdraw', activeIcon: withdrawActive, inactiveIcon: withdrawInactive },
    { path: '/affiliateDash', name: 'Affiliate', activeIcon: affiliateActive, inactiveIcon: affiliateInactive },
    // Mobile-only: on desktop the profile card at the bottom of the sidebar covers this
    { path: '/settings', name: 'Profile', icon: <FaUser size={22} />, mobileOnly: true },
    ...(user?.admin === true ? [{ path: '/adminPanel', name: 'Admin', icon: <FaUserShield size={22} /> }] : []),
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-top">
          <div className="sidebar-nav-items">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-item ${isActive ? 'active' : ''} ${item.mobileOnly ? 'nav-item-mobile' : ''}`}
                >
                  <span className="nav-icon">
                    {item.icon
                      ? item.icon
                      : <img src={isActive ? item.activeIcon : item.inactiveIcon} alt="" draggable="false" />}
                  </span>
                  <span className="nav-text">{item.name}</span>
                </Link>
              );
            })}
          </div>

          <button
            type="button"
            className="sidebar-download-button"
            onClick={handleDownload}
            disabled={generatingLink}
          >
            <span>{generatingLink ? 'Generating Link...' : 'Download App'}</span>
          </button>
          {downloadError && (
            <span className="sidebar-download-error">{downloadError}</span>
          )}
        </div>

        <SidebarProfile />
      </div>
    </div>
  );
};

export default Sidebar;
